import template from './form.html';
import detallesTemplate from './detalles.html';
import modalTemplate from '../detalles-list/cancelar.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import ordenesI18N from 'i18n/ordenes/es.json';
import commonI18N from 'i18n/common/es.json';
import { daysOfWeekMapHorarios, daysOfWeekMapHabilitados, sortAdicionalesServicio } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let OrdenFormComponent = {
  templateUrl: template,
  selector: 'ordenForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(ordenesI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', 'CustomModal', '$q'
];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, CustomModal, $q) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.loadClientes = loadClientes.bind(this);
  this.loadServicios = loadServicios.bind(this);
  this.loadProductos = loadProductos.bind(this);
  this.loadEspecialistas = loadEspecialistas.bind(this);
  this.loadVendedores = loadVendedores.bind(this);
  this.newDetalle = newDetalle.bind(this);
  this.newDetalleProducto = newDetalleProducto.bind(this);
  this.deleteDetalle = deleteDetalle.bind(this);
  this.verDetalles = verDetalles.bind(this);
  this.renderCliente = renderCliente.bind(this);
  this.renderServicio = renderServicio.bind(this);
  this.renderProducto = renderProducto.bind(this);
  this.renderEspecialista = renderEspecialista.bind(this);
  this.filterEspecialista = filterEspecialista.bind(this);
  this.filterServicio = filterServicio.bind(this);
  this.renderDisponibilidad = renderDisponibilidad.bind(this);
  this.renderEspecialistaSinSeleccion = renderEspecialistaSinSeleccion.bind(this);
  this.onSelectEmpleado = onSelectEmpleado.bind(this);
  this.onSelectServicio = onSelectServicio.bind(this);
  this.hasPaquete = hasPaquete.bind(this);

  let unsubscribe;

  const valoresFilter = Filter.path('tipo.codigo').eq('estado_orden_trabajo');

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver orden'] : this.translations['Editar orden'];
      this.formEdit('ordenes-de-trabajo', $stateParams.uid);
    } else {
      this.title = this.translations['Nueva orden'];
      this.form();
    }
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
  };

  this.localModel = {};

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = state.form.model;

    if (!this.model.id && state.valores.data && state.valores.data.length > 0) {
      this.estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_orden_trabajo');
      let estadoCreado = this.estados.filter(v => v.value === 'No Confirmada')[0];
      this.model.estado = estadoCreado;
      this.localModel.numero = this.translations['Autogenerado'];
      if (!this.model.detalles) {
        this.model.detalles = [];
      }
    } else if (!this.modelInit && this.model.id) {
      this.modelInit = true;
      let [fecha, hora] = this.model.fecha.split(' ');
      this.localModel.fecha = moment(fecha, 'DD/MM/YYYY').toDate();
      this.localModel.hora = hora;
      this.localModel.numero = this.model.numero;
    }

    return {
      form: state.form
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.ordenes.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.ordenes.list');
    }
  }

  function doSubmit() {
    let data = Object.assign({}, this.model);
    let detalles = [];

    data.detalles.forEach(function(detalle) {
      let dataDetalle = Object.assign({}, detalle);
      dataDetalle.servicioId = detalle.servicio.id;
      dataDetalle.servicio = null;
      dataDetalle.detalles = null;
      detalles.push(dataDetalle);
    });
    data.detalles = detalles;

    let detallesProducto = [];
    data.detallesProducto.forEach(function(detalle) {
      let detalleProducto = Object.assign({}, detalle);
      if (detalleProducto.especialista) {
        detalleProducto.especialista = {id: detalleProducto.especialista.id};
      }
      detalleProducto.producto = detalleProducto.producto.id;
      detallesProducto.push(detalleProducto);
    });

    data.detallesProducto = detallesProducto;

    this.save('ordenes-de-trabajo', data);
  }

  this.daysOfWeekMapHorarios = daysOfWeekMapHorarios;
  this.daysOfWeekMapHabilitados = daysOfWeekMapHabilitados;

  function renderDisponibilidad(disponibilidad, date) {
    var weekDayName = moment(date).format('dddd');
    let dayOfWeek = date.getDay();
    let horarios = disponibilidad[this.daysOfWeekMapHorarios[dayOfWeek]];
    let rangos = [];

    horarios.forEach(function(rango) {
      if (rango.inicio !== rango.fin) {
        rangos.push(`De ${rango.inicio/2} hs. a ${rango.fin/2} hs.`);
      }
    });

    return `<strong>${weekDayName}:</strong> ${disponibilidad[this.daysOfWeekMapHabilitados[dayOfWeek]] ? rangos.join(' - '): 'No Disponible'}`;
  }

  function renderEspecialista(empleado) {
    return `<div class="especialista-orden">${empleado.nombre} ${empleado.apellido} <div class="select-detalles"><small>${this.renderDisponibilidad(empleado.disponibilidad, this.localModel.fecha)}</></div></div>`;
  }

  function renderEspecialistaSinSeleccion(empleado) {
    return `<div class="especialista-orden">${empleado.nombre} ${empleado.apellido} </div>`;
  }


  function renderCliente(cliente) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    return `${cliente.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }

  function newDetalle() {
    let detallesExtra = this.model.detalles.filter(v => v.codigo && (v.codigo.split('-')[1]).startsWith('E')).map(v => parseInt(v.codigo.split('-')[2])).sort();

    let detallesExtraCita = this.model.detalles.filter(v => v.codigo && (v.codigo.split('-')[1]).startsWith('E'))
      .map(v => {
        return {
          detalle: v,
          nro: parseInt(v.codigo.split('-')[2])
        };
      }).sort(function(a, b) { return a.nro > b.nro; });
    let detallesCita = this.model.detalles.filter(
        v => v.codigo && ((v.codigo.split('-')[1]).startsWith('DC') || (v.codigo.split('-')[1]).startsWith('DT'))
      ).map(v => {
        return {
          detalle: v,
          nro: parseInt(v.codigo.split('-')[2])
        };
      }).sort(function(a, b) { return a.nro > b.nro; });

    let detalleAnterior;
    if (detallesExtraCita.length) {
      detalleAnterior = detallesExtraCita[detallesExtraCita.length - 1].detalle;
    } else {
      detalleAnterior = detallesCita[detallesCita.length - 1].detalle;
    }
    let fechaCita = moment.utc(detalleAnterior.fechaCita, 'DD/MM/YYYY HH:mm').add(detalleAnterior.servicio.duracion, 'minutes');
    let tipo = detalleAnterior.tipo;

    this.model.detalles.push({
      codigo: `${this.model.numero}-E-${detallesExtra.length ? detallesExtra[detallesExtra.length - 1] + 1 : 1}`,
      fechaCita: fechaCita.format('DD/MM/YYYY HH:mm'),
      tipo
    });
  }

  function newDetalleProducto() {
    let detallesExtra = this.model.detallesProducto;

    this.model.detallesProducto.push({
      codigo: `${this.model.numero}-P-${detallesExtra.length + 1}`,
      cantidad: 1
    });
  }


  function deleteDetalle(detalle) {
    if (!detalle.id) {
      _.remove(this.model.detalles, detalle);
      return;
    }

    let self = this;
    let payload = {};
    CustomModal.open({
      title: 'Cancelar',
      id: detalle.id,
      payload,
      templateUrl: modalTemplate,
      autorizar: detalle.estadoDetalle.value === 'En proceso',
      message: '¿Seguro que desea cancelar el detalle de orden?',
      ok: function() {

        $ngRedux.dispatch(rest.actions.cancelarDetalle({ id: detalle.id }, {
          body: JSON.stringify(payload)
        }, (err, data) => {
          if (!err && data.estadoDetalle.value === 'Cancelado') {
            ngNotify.set(self.translations['Cancelado Correctamente'], 'success');
            detalle.estadoDetalle = data.estadoDetalle;
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }

  this.deleteDetalleProducto = deleteDetalleProducto.bind(this);


  function deleteDetalleProducto(detalle) {
    if (!detalle.id) {
      _.remove(this.model.detallesProducto, detalle);
      return;
    }

    let self = this;
    let payload = {};
    CustomModal.open({
      title: 'Borrar Detalle Producto',
      id: detalle.id,
      payload,
      templateUrl: modalTemplate,
      producto: true,
      autorizar: false,
      message: '¿Seguro que desea borrar el detalle producto de orden?',
      ok: function() {

        $ngRedux.dispatch(rest.actions.cancelarDetalleProducto({ id: detalle.id }, {
          body: JSON.stringify(payload)
        }, (err, data) => {
          if (!err) {
            ngNotify.set(self.translations['Borrado Correctamente'], 'success');
            _.remove(self.model.detallesProducto, detalle);
          } else if (err) {
            ngNotify.set(err.message, 'warn');
          }
        }));
      }
    });
  }



  function verDetalles(item) {
    let self = this;
    this.localModel.payload = {
      adicionales: {},
      usoInsumo: {}
    };

    mapDetallesTerminar(item.servicio).then(function(value) {
      let { list, obligatorios, adicionales } = value;
      self.localModel.obligatorios = obligatorios;
      self.localModel.adicionales = adicionales;
      // console.log(value);
      // console.log(item.detalles);

      let detallesUtilizados = {};
      item.detalles.forEach(function(detalleUtilizado) {
        detallesUtilizados[detalleUtilizado.precioDetalle] = true;
        if (detalleUtilizado.adicional) {
          let id = `${detalleUtilizado.adicional}-${detalleUtilizado.tipoProductoAdicional}`;

          // if (!id) {
          //   id = `${detalleUtilizado.adicional}-${detalleUtilizado.tipoProductoAdicional}`;
          // }
          self.localModel.payload.usoInsumo[id] = self.localModel.payload.usoInsumo[id] || [];

          self.localModel.payload.usoInsumo[id].push({
            uso: detalleUtilizado.usoInsumo,
            cantidad: detalleUtilizado.cantidadUtilizada,
            cantidadMostrada: detalleUtilizado.cantidadDosis
          });

          self.localModel.payload.adicionales[id] = true;
        } else {
          self.localModel.payload.adicionales[detalleUtilizado.precioDetalle] = true;
        }
      });

      function updateCantidadMostrada(detalle) {
        detalle.cantidadMostrada = detalle.uso.cantidadDosisMinima + ((detalle.cantidad - 1) * detalle.uso.dosisAdicional);
      }

      let options = {
        size: 'lg',
        title: 'Detalles de Finalización',
        item: item,
        vm: self,
        templateUrl: detallesTemplate,
        empleado: self.model,
        view: self.view,
        actionLabel: self.view ? 'Aceptar' : 'Actualizar',
        servicio: item.servicio,
        detalles: list,
        payload: self.localModel.payload,
        clearSearch: function(modal) {
          modal.search = null;
        },
        toggleUtilizar: (detalle) => {
          if (detalle.adicional && detalle.adicional.controlStock) {
            self.localModel.payload.usoInsumo[detalle.id] = [{ cantidad: 1 }];
          }
        },
        selectUsoInsumo: (detalle, index) => {

          self.localModel.payload.usados = {};
          self.localModel.payload.usoInsumo[detalle.id].forEach((element) => {
            self.localModel.payload.usados[element.uso.id] = true;
          });

          if (!self.localModel.payload.usoInsumo[detalle.id][index].cantidad) {
            self.localModel.payload.usoInsumo[detalle.id][index].cantidad = 1;
            updateCantidadMostrada(self.localModel.payload.usoInsumo[detalle.id][index]);
          }

        },
        toggleDown: function(detalle, index) {
          if (self.localModel.payload.usoInsumo[detalle.id][index].cantidad > 0) {
            self.localModel.payload.usoInsumo[detalle.id][index].cantidad--;
            updateCantidadMostrada(self.localModel.payload.usoInsumo[detalle.id][index]);
          }
        },
        toggleUp: function(detalle, index) {
          self.localModel.payload.usoInsumo[detalle.id][index].cantidad++;
          updateCantidadMostrada(self.localModel.payload.usoInsumo[detalle.id][index]);
        },
        addUsoInsumo: function(detalle) {
          self.localModel.payload.usoInsumo[detalle.id].push({ cantidad: 1 });
        },
        removeUsoInsumo: function(detalle, index) {
          self.localModel.payload.usoInsumo[detalle.id].splice(index, 1);
        },
        loadUsosInsumo: function(query, detalle) {
          let filter = Filter.path('estado.value').eq('Activo').and(Filter.path('producto.id').eq(detalle.adicional.id));
          if (query) {
            filter = filter.and(Filter.path('codigo').like(query));
          }
          BasicFactory.setup('usos-insumo');
          return BasicFactory.all({ filter: JSON.stringify(filter) });
        },
        renderUsoInsumo: function(item) {
          let info = ` - Stock: ${item.cantidad - item.cantidadUtilizada}`;

          if (item.producto && item.producto.unidadMedida) {
            info += ` (${item.producto.unidadMedida.nombre})`;
          }

          return `${item.codigo}${info}`;
        },
        messageClass: 'font-large',
        headerClass: 'font-large',
        ok: function() {
          if (self.view) {
            return;
          }

          let payload = {};
          payload.adicionales = Object.keys(self.localModel.payload.adicionales)
            .filter(v => self.localModel.payload.adicionales[v]).map((e, index) => {
              return {
                fakeId: e,
                id: !self.localModel.adicionales[e].adicional ? e : -index,
                adicionalId: self.localModel.adicionales[e].adicional ? self.localModel.adicionales[e].adicional.id : null,
                tipoAdicionalId: self.localModel.adicionales[e].tipoProductoAdicional.id
              };
            });
          let faltan = [];
          Object.keys(obligatorios).forEach(function(key) {
            let marcados = Object.keys(self.localModel.payload.adicionales).filter(v => self.localModel.adicionales[v].tipoProductoAdicional.adicional.id == key);

            if (!marcados.length) {
              faltan.push(obligatorios[key].nombre);
            }
          });

          if (faltan.length) {
            ngNotify.set(`Debe indicar tipo adicional: ${faltan.join(' - ')}`, 'warn');
            return false;
          }
          payload.usoInsumo = {};
          faltan = [];
          payload.adicionales.forEach(function(element) {
            let key = element.fakeId;
            let index = element.id;
            if (self.localModel.payload.usoInsumo[key]) {
              self.localModel.payload.usoInsumo[key].forEach(function(usoDetalle) {
                if (!usoDetalle.uso) {
                  faltan.push(self.localModel.adicionales[key].adicional.nombre);
                  return;
                }
                payload.usoInsumo[index] = payload.usoInsumo[index] || [];
                payload.usoInsumo[index].push({
                  cantidad: usoDetalle.cantidad,
                  cantidadDosis: usoDetalle.cantidadMostrada,
                  usoInsumoId: usoDetalle.uso.id
                });
              });
            }
          });

          if (faltan.length) {
            ngNotify.set(`Debe indicar el Insumo Usado: ${faltan.join(' - ')}`, 'warn');
            return false;
          }

          $ngRedux.dispatch(rest.actions.actualizarDetalle({ id: item.id }, {
            body: JSON.stringify(payload)
          }, (err, data) => {
            if (!err && data.estadoDetalle.value === 'Finalizado') {
              ngNotify.set(self.translations['Actualizada Correctamente'], 'success');
              item.detalles = data.detalles;
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
        }
      };
      CustomModal.open(options);
    });
  }


  function mapDetallesTerminar(servicio) {
    return $q(function(resolve, reject) {
      $ngRedux.dispatch(rest.actions.insumosControlados({ id: servicio.id }, {
        body: JSON.stringify({})
      }, (err, data) => {
        if (!err) {
          resolve(mapDetalles(servicio, data));
        } else if (err) {
          ngNotify.set(err.message, 'warn');
          reject(err);
        }
      }));
    });
  }

  function mapDetalles(servicio, productosControlados) {
    let obligatorios = {};
    let adicionales = {};
    let mapDetalles = {
      adicionales: {
        tipo: {
          adicional: { nombre: 'Otros Adicionales' },
          otros: true
        },
        detalles: []
      }
    };
    if (servicio.precio) {
      let detalles = productosControlados.concat(servicio.precio.detalles);
      detalles.forEach(function(element) {
        if (element.tipoProductoAdicional.obligatorio) {
          obligatorios[element.tipoProductoAdicional.adicional.id] = element.tipoProductoAdicional.adicional;
        }

        if (element.id < 0) {
          element.id = element.fakeId;
        } else if (element.adicional) {
          element.id = `${element.adicional.id}-${element.tipoProductoAdicional.id}`;
        }

        adicionales[element.id] = element;
        if (element.adicional) {
          let mapDetalle = mapDetalles[element.tipoProductoAdicional.id] || {
            tipo: element.tipoProductoAdicional,
            detalles: []
          };
          mapDetalle.detalles.push(element);

          mapDetalles[element.tipoProductoAdicional.id] = mapDetalle;
        } else {
          mapDetalles.adicionales.detalles.push(element);
        }
      });
    }

    let list = [];
    Object.keys(mapDetalles).forEach(function(key) {
      let detalle = mapDetalles[key];
      detalle.detalles = detalle.detalles.filter((v) => v.tipoProductoAdicional.adicional.activo).sort(sortAdicionalesServicio);
      list.push(detalle);
    });

    return { list, obligatorios, adicionales };
  }

  this.renderHora = renderHora.bind(this);

  function renderHora(item) {
    return item ? item.split(' ')[1] : '-';
  }

  function renderServicio(item) {
    return item.nombre;
  }

  function renderProducto(item) {
    return item.nombre;
  }


  function loadServicios(query) {
    let filter = Filter.path('categoria.clase.value').eq('Servicio')
    .and(Filter.path('activo').eq(true))
    .and(Filter.path('estado.value').eq('Activo'))
    .and(Filter.path('servicioPadre.id').isNull());

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.filterServicio = filterServicio.bind(this);
  function filterServicio(servicio) {
    return servicio.precio;
  }

  function loadProductos(query) {
    let filter = Filter.path('categoria.clase.value').eq('Producto')
      .and(Filter.path('precio').notNull())
      .and(Filter.path('estado.value').eq('Activo'));

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query));
    }

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function filterEspecialista(especialista) {
    if (especialista.disponibilidad) {
      return this.checkDisponibilidad(especialista.disponibilidad, this.localModel.fecha);
    } else {
      return false;
    }
    //    return true;
  }

  this.checkDisponibilidad = checkDisponibilidad.bind(this);

  function checkDisponibilidad(disponibilidad, date, checkHora) {
    if (!date) return true;

    let dayOfWeek = date.getDay();

    let habilitado = disponibilidad[this.daysOfWeekMapHabilitados[dayOfWeek]];
    if (!habilitado) return false;

    if (!checkHora) return true;

    let horarios = disponibilidad[this.daysOfWeekMapHorarios[dayOfWeek]];
    let hour = date.getHours();
    let min = date.getMinutes();
    if (min > 0) {
      hour = hour + 1;
    }

    let disponible = false;
    horarios.some(function(rango) {
      let hora2 = hour * 2;
      if (rango.inicio <= hora2 && rango.fin > hora2) {
        disponible = true;
        return true;
      }
    });

    return disponible;
  }

  function filterServicio(servicio) {
    return servicio.precio;
  }

  function onSelectEmpleado(detalle) {
    let dayOfWeek = this.localModel.fecha.getDay();
    let fechaCita = moment(detalle.fechaCita, 'DD/MM/YYYY HH:mm').toDate();

    if (!this.checkDisponibilidad(detalle.especialista.disponibilidad, fechaCita, true)) {
      ngNotify.set(this.translations['Especialista no disponible en fecha/hora seleccionados'], 'warn');
      detalle.especialista = undefined;
      return;
    }
  }

  function onSelectServicio(detalle) {}

  function loadEspecialistas(query, detalle) {
    let especialidades = [];
    detalle.servicio.especialidades.forEach(function(especialidad) {
      especialidades.push(especialidad.id);
    });

    let filter = Filter.path('tipoEmpleado.value').eq('Especialista').and(Filter.path('activo').eq(true))
      .and(Filter.path('especialidades.id').in(especialidades));

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function loadVendedores(query, detalle) {

    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function loadClientes(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('clientes');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  /**
   * Retorna un valor truthy si la OT tiene cita y algun detalle de cita tiene paquete, un valor falsy caso contrario.
   * @returns {*|{actual: {}, excepcion: {}, detalles: []}|{actual: {}, excepcion: {}, detalles: []}|[]|number}
   */
  function hasPaquete() {
    return this.model
      && this.model.cita
      && this.model.cita.detalles
      && this.model.cita.detalles.length
      && this.model.cita.detalles.map(d => d.paquete).filter(p => p).length;
  }
}



// WEBPACK FOOTER //
// ./src/components/ordenes/form/form.component.js